import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private loadingAlert: any;
  constructor() { }
  /**
    * Muestra una alerta simple.
    *
    * @param {string} title - El título de la alerta.
    * @param {string} text - El texto de la alerta.
    * @param {number} [timer] - El tiempo en milisegundos que durará la alerta.
    * @param {'success' | 'error' | 'warning' | 'info' | 'question'} [icon='info'] - El ícono de la alerta.
    * @returns {Promise<SweetAlertResult>} - Devuelve una promesa con el resultado de la alerta.
    */
  showAlert(title: string, text: string, icon: 'success' | 'error' | 'warning' | 'info' | 'question' = 'info', timer?: number) {
    return Swal.fire({
      title,
      text,
      icon,
      timer,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#3085d6',
    });
  }

  /**
    * Muestra una alerta de confirmación.
    *
    * @param {string} title - El título de la alerta de confirmación.
    * @param {string} text - El texto de la alerta de confirmación.
    * @param {number} [timer] - El tiempo en milisegundos que durará la alerta.
    * @returns {Promise<SweetAlertResult>} - Devuelve una promesa con el resultado de la confirmación.
    */
  showConfirm(title: string, text: string) {
    return Swal.fire({
      title,
      text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, continuar',
      cancelButtonText: 'No, cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',     // azul
    });
  }

  /**
    * Muestra una alerta de éxito.
    *
    * @param {string} title - El título de la alerta de éxito.
    * @param {string} text - El texto de la alerta de éxito.
     * @param {number} [timer] - El tiempo en milisegundos que durará la alerta.
    * @returns {Promise<SweetAlertResult>} - Devuelve una promesa con el resultado de la alerta.
    */
  showSuccess(title: string, text: string, timer?: number) {
    return this.showAlert(title, text, 'success', timer);
  }

  /**
   * Muestra una alerta de error.
   *
   * @param {string} title - El título de la alerta de error.
   * @param {string} text - El texto de la alerta de error.
   * @param {number} [timer] - El tiempo en milisegundos que durará la alerta.
   * @returns {Promise<SweetAlertResult>} - Devuelve una promesa con el resultado de la alerta.
   */
  showError(title: string, text: string, timer?: number) {
    return this.showAlert(title, text, 'error', timer);
  }

  /**
   * Muestra una alerta de carga.
   *
   * @param {string} title - El título de la alerta de carga.
   * @param {string} [text] - El texto opcional de la alerta de carga.
   * @returns {void}
   */
  showLoading(title: string, text?: string) {
    Swal.fire({
      title,
      text,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false
    });
    Swal.showLoading();
  }



  /**
   * Cierra la alerta de carga si está abierta.
   *
   * @returns {void}
   */
  closeLoading() {
    Swal.close();
  }
}
